import React from 'react';
import { useNavigate } from 'react-router-dom';
import { GlifoTipo } from '../estacionamiento/Emblemas';

// Aviso sobrio del módulo Estacionamiento (CA1): sin animación, en claro, con un
// tramo del plano real del piso 3 (puestos 115 a 110: cuatro de SURA y dos de
// gerencia) dibujado igual que en el módulo. Sale por fechas; para quitarlo
// antes, comentar el render en HomeView.

// Desde cuándo sale ('AAAA-MM-DD') y cuántos días
const DESDE = '2026-11-02';
const DIAS_VISIBLE = 14;
const RUTA = '/estacionamiento';

const EN_DESARROLLO = process.env.NODE_ENV === 'development';

function enFechas() {
  if (EN_DESARROLLO) return true;
  const inicio = new Date(`${DESDE}T00:00:00`);
  const fin = new Date(inicio.getTime() + DIAS_VISIBLE * 86400000);
  const ahora = new Date();
  return ahora >= inicio && ahora < fin;
}

// Fila inferior del plano, de izquierda a derecha como en la lámina
const TRAMO = [
  { numero: 115, tipo: 'privado_sura' },
  { numero: 114, tipo: 'privado_sura' },
  { numero: 113, tipo: 'privado_sura' },
  { numero: 112, tipo: 'privado_sura' },
  { numero: 111, tipo: 'gerencia' },
  { numero: 110, tipo: 'gerencia' },
];

const styles = `
.ec-contenedor{container-type:inline-size}
.ec{
  --ec-navy:#132752; --ec-azul:#003366; --ec-suave:#5A6784; --ec-borde:#DCE3EF;
  position:relative; display:grid; grid-template-columns:minmax(0,1fr) auto; align-items:stretch;
  background:#FFFFFF; border:1px solid var(--ec-borde); border-radius:1.25rem; overflow:hidden;
  box-shadow:0 1px 2px rgba(19,39,82,.05); cursor:pointer;
}
.ec-texto{padding:22px 24px 22px 26px; display:flex; flex-direction:column; justify-content:center; min-width:0}
.ec-titulo{margin:0; color:var(--ec-navy); font-size:1.2rem; line-height:1.2; font-weight:800; letter-spacing:-.012em}
.ec-bajada{margin:6px 0 0; color:var(--ec-suave); font-size:14px; line-height:1.45; max-width:34rem}
.ec-cta{
  align-self:flex-start; margin-top:14px; display:inline-flex; align-items:center; height:36px; padding:0 16px;
  border-radius:10px; border:0; background:var(--ec-azul); color:#FFFFFF; font-size:13.5px; font-weight:700;
  cursor:pointer; transition:background-color .15s ease;
}
.ec-cta:hover{background:#0A4380}
.ec-cta:focus-visible{outline:3px solid var(--ec-azul); outline-offset:3px}

/* Tramo del plano: piso punteado, carril y la fila de puestos */
.ec-piso{
  position:relative; display:flex; flex-direction:column; justify-content:flex-end; gap:12px;
  padding:16px 22px 18px 34px; border-left:1px solid #E6EBF4;
  background:radial-gradient(circle at 1px 1px,rgba(19,39,82,.075) 1px,transparent 1.5px) 0 0/16px 16px,
    linear-gradient(180deg,#F9FBFE 0%,#EEF2F9 100%);
  -webkit-mask-image:linear-gradient(90deg,transparent 0,#000 34px);
  mask-image:linear-gradient(90deg,transparent 0,#000 34px);
}
.ec-carril{height:0; border-top:2px dashed rgba(19,39,82,.15)}
.ec-fila{display:flex; gap:6px}
.ec-puesto{
  width:46px; height:72px; flex:none; display:flex; flex-direction:column; align-items:center; justify-content:space-between;
  padding:7px 0 8px; border-radius:8px; border:1.5px solid var(--ec-navy);
  background:linear-gradient(180deg,#CBDAF0 0%,#B5C9E6 100%);
  box-shadow:inset 0 1px 0 rgba(255,255,255,.8),0 1px 2px rgba(19,39,82,.16);
}
.ec-num{font-size:12px; line-height:1; font-weight:800; font-variant-numeric:tabular-nums; color:var(--ec-navy)}
.ec-glifo{flex:1; display:flex; align-items:center; justify-content:center}
.ec .est-glifo-doble{display:inline-flex; flex-direction:column; align-items:center; gap:1px}

@container (max-width: 600px){
  .ec{grid-template-columns:minmax(0,1fr)}
  .ec-texto{padding:20px 20px 16px}
  .ec-piso{border-left:0; border-top:1px solid #E6EBF4; padding:14px 20px 16px; overflow:hidden;
    -webkit-mask-image:linear-gradient(90deg,#000 calc(100% - 40px),transparent 100%);
    mask-image:linear-gradient(90deg,#000 calc(100% - 40px),transparent 100%)}
}
`;

const EstacionamientoCa1Banner = () => {
  const navigate = useNavigate();
  if (!enFechas()) return null;

  const abrir = () => navigate(RUTA);

  return (
    <div className="ec-contenedor">
      <style>{styles}</style>
      <section className="ec" aria-labelledby="ec-titulo" onClick={abrir}>
        <div className="ec-texto">
          <h3 id="ec-titulo" className="ec-titulo">Estacionamiento de la Torre CA1</h3>
          <p className="ec-bajada">
            Consulta los puestos asignados al equipo de SURA en el piso 3 y cuáles puede usar todo el personal.
          </p>
          <button
            type="button"
            className="ec-cta"
            onClick={(e) => { e.stopPropagation(); abrir(); }}
          >
            Ver los puestos
          </button>
        </div>

        <div className="ec-piso" aria-hidden="true">
          <div className="ec-carril" />
          <div className="ec-fila">
            {TRAMO.map(({ numero, tipo }) => (
              <div key={numero} className="ec-puesto">
                <span className="ec-num">{numero}</span>
                <span className="ec-glifo"><GlifoTipo tipo={tipo} escala={tipo === 'gerencia' ? 34 : 26} /></span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default EstacionamientoCa1Banner;
